import {DeploymentVerificationDetailsResponse} from './graphql/deployment-verification-details.js';

export interface Build {
  id: string;
  assetPath: string;
}

export interface ClientError extends Error {
  statusCode: number;
}

export interface DeploymentHooks {
  buildFunction?: (urlPath?: string) => Promise<void>;
  onDeploymentCompletedVerificationStart?: () => void;
  onDeploymentCompletedVerificationError?: () => void;
  onDeploymentFailed?: (
    responseData: DeploymentVerificationDetailsResponse,
  ) => void;
  onDeploymentCompleted?: () => void;
  onVerificationStart?: () => void;
  onVerificationComplete?: () => void;
  onVerificationError?: (error: Error) => void;
  onUploadFilesStart?: () => void;
  onUploadFilesError?: (error: Error) => void;
  onUploadFilesComplete?: () => void;
}

export interface DeploymentConfig {
  assetsDir?: string;
  bugsnag: boolean;
  buildCommand?: string;
  deploymentToken: DeploymentToken;
  deploymentUrl: string;
  environmentTag?: string;
  metadata: {
    description?: string;
    hydrogenVersion?: string;
    user?: string;
    version?: string;
    url?: string;
  };
  defaultEnvironment: boolean;
  rootPath?: string;
  skipBuild: boolean;
  workerDir?: string;
  workerOnly: boolean;
  generateAuthBypassToken: boolean;
  authBypassTokenDuration?: string;
  overriddenEnvironmentVariables?: EnvironmentVariable[];
}

export interface EnvironmentVariable {
  isSecret: boolean;
  key: string;
  value: string;
}

export interface DeploymentToken {
  accessToken: string;
  allowedResource: string;
  appId: string;
  client: string;
  expiresAt: string;
  namespace: string;
  namespaceId: string;
}

export interface DeploymentManifestFile {
  filePath: string;
  fileSize: number;
  mimeType: string;
  fileHash: string;
  fileType: string;
}

export interface EnvironmentInput {
  handle?: string;
  tag?: string;
}

export enum FileType {
  Worker = 'WORKER',
  Asset = 'ASSET',
}

export interface OxygenError {
  message: string;
}

export class DeploymentCompletedVerificationError extends Error {}
